import { SpacingsValues } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignItems: 'center',
      gap: SpacingsValues.s64,
      marginBottom: 40,
      marginInline: 'auto',
      maxWidth: 'min(100%, var(--max-width-02))',
      paddingBlock: SpacingsValues.s56,

      '& .hr': {
        display: 'block',
        marginBottom: 16,
      },

      '& .lst': {
        paddingLeft: 24,
      },

      [mediaQuery(breakpoints.desktop)]: {
        gap: SpacingsValues.s32,
      },

      '& .br': {
        display: 'block',
      },
      [mediaQuery(1490)]: {
        paddingInline: 24,
      },

      [mediaQuery(breakpoints.laptop)]: {
        flexDirection: 'column',
        marginBottom: 0,
        paddingBlock: SpacingsValues.s40,

        '& .br': {
          display: 'inline',
        },
      },
    },
    inverseImage: {
      flexDirection: 'row-reverse',

      [mediaQuery(breakpoints.laptop)]: {
        flexDirection: 'column',
      },
    },

    textContainer: {
      paddingLeft: 0,
      paddingRight: 172,

      [mediaQuery(breakpoints.largeDesktop)]: {
        maxWidth: '100%',
        paddingRight: 0,
      },
    },
    inverseTextContainer: {
      paddingLeft: 172,
      paddingRight: 0,

      [mediaQuery(breakpoints.largeDesktop)]: {
        paddingLeft: 0,
      },
    },

    title: {
      color: 'var(--x-black)',
      fontSize: 42,
      lineHeight: '50px',
      fontWeight: 500,
      marginBottom: SpacingsValues.s16,

      [mediaQuery(breakpoints.laptop)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },

    titlePadded: {
      marginBottom: SpacingsValues.s32,
    },

    description: {
      color: '#666',

      '& ol': {
        paddingLeft: 18,
        paddingBottom: 16,
      },
      '& ul': {
        listStyleType: 'disc',
        paddingLeft: 18,
        paddingBottom: 16,
      },
      '& li': {
        paddingBlock: 4,
      },
      '& span': {
        display: 'block',
        marginTop: 8,
      },
      '& a': {
        color: '#666',
        textDecoration: 'underline',
      },
    },
  }),
  {
    name: 'ImageWithText',
  },
);

export default useStyles;
